import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/PodcastBack.svg'

export const IconPodcastBack = IconSVG as IconComponent
